import React from 'react';
import MembersApi from '../../../../services/portal-api/MembersApi';
import moment from "moment/moment";
import PageTitle from '../../../../components/PageTitle';
import Header from '../../../../components/Header';
import withAuth from '../../../../services/withAuth';
import swal from 'sweetalert';
import AuthService from '../../../../services/AuthService';
import NotFound from '../../../NotFound';

class JobDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            jobId: this.props.match.params.id,
            category: this.props.match.params.cat,
            data: {},
            columns: [],
        }

    }

    componentDidMount() {
        MembersApi.getJobs((response) => {
            if (response.success) {
                const cols = Object.keys(response.json.result);
                this.setState({
                    data: response.json.result,
                    columns: cols,
                    retrying: false
                }, () => { console.log(this.state) });

            } else {
                if (response.status === 401) {
                    this.props.sessionExpired();
                    return;
                } else {
                    // alert("Sorry, Unable to fetch View job details");
                    swal("Sorry, Unable to fetch View job details", {
                        icon: "warning",
                        buttons: false,
                        timer: 3000
                    });
                }

            }
        }, this.state.category, this.state.jobId);
    }

    convertUTCToLocalTime = (dateString) => {
        let date = new Date(dateString);
        const milliseconds = Date.UTC(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            date.getHours(),
            date.getMinutes(),
            date.getSeconds(),
        );
        const localTime = new Date(milliseconds);
        let cd = localTime.getFullYear() + "-" + (localTime.getMonth() + 1) + "-" + localTime.getDate() + " " + localTime.getHours() + ":" + localTime.getMinutes() + ":" + localTime.getSeconds();
        return moment(cd).format('DD/MM/YYYY h:mm A');
    };

    render() {
        let rows = [];
        let title = this.state.category.split("_");
        for (let i = 0; i < title.length; i++) {
            title[i] = title[i][0].toUpperCase() + title[i].substr(1);
        }

        title = title.join(" ") + " Job #" + this.state.jobId;

        this.state.columns.forEach((col, index) => {
            rows.push(<tr key={index}><td><strong>{col}</strong></td><td>{this.state.data[col] == null ? " -- " : this.state.data[col]}</td></tr>);
        });
        console.log("v", this.state.columns);
        return (
            AuthService.can('jobs') ?
            <div>
                <Header />
                <main className="content" role="main">
                    <div className="container container--wide padding--60">

                        <header className="header--page clearfix">

                            <PageTitle back="/" title={title} />

                        </header>
                        <div className="margin--60--top validate loading--inline " >
                            <table style={{ fontSize: 15 }}>
                                <thead>
                                    <tr>
                                        <th><strong>Column</strong></th>
                                        <th><strong>Data</strong></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {rows}
                                    {rows.length === 0 &&
                                        <tr>
                                            <td colSpan="2">No results founds.</td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </main>
            </div>
            : <NotFound forbidden={true} />
        );
    }


}

export default withAuth(JobDetails);